import React from "react";
import { appStyles } from "../../../utils/appStyle";
import Block from "../../../component/block";
import mixpanel from "mixpanel-browser";
import { logContentBlockPressEvent } from "../../../utils/events";
import { useAppContext } from './../../../util'

// render Link Component
function Link({ icon, buttonText, url, color, highlight, index, contentBlockId }) {

  const { userId, pageId } = useAppContext()

  const STYLES = appStyles(color, highlight);

  const handleClicked = () => {
    logContentBlockPressEvent(contentBlockId)
    mixpanel.track("Web Link Clicked", {
      Button_type: "link",
      distinct_id: userId,
      stack_id: pageId,
    })
  }

  return (
    <div
      key={index}
      style={{
        marginTop: "8px",
        borderRadius: STYLES.borderRadius,
        border: STYLES.border,
        background: STYLES.background,

      }}
      onClick={handleClicked}
    >
      <a
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px",
          color: STYLES.Color,
          listStyle: "none",
          textDecoration: "none",
        }}
        href={
          url.includes("http")
            ? url
            : `https://www.google.com/search?q=${encodeURIComponent(url)}`
        }
        target="_blank" rel="noreferrer"
      >
        <Block
          icon={icon}
          content={buttonText}
          rightIcon="fa-sharp fa-solid fa-chevron-right"
        />
      </a>
    </div>
  );
}

// export component Link
export default Link;
